import React, { Suspense } from "react";
import * as THREE from "three";
import { Canvas } from "@react-three/fiber";
import {
  OrbitControls,
  Environment,
  Html,
  useProgress,
} from "@react-three/drei";

import Model from "./Model";
import dtshirt from "../../images/3dtshirt.glb"

function Loader() {
  const { progress } = useProgress();

  return (
    <Html center>
      <div className="text-white">{Math.floor(progress)}%</div>
    </Html>
  );
}

export default function ThreeViewer() {
  return (
    <Canvas
      dpr={1}   
      shadows
      camera={{ position: [-25, 10, 0], fov: 45 }}
      gl={{
        antialias: true,
        outputColorSpace: THREE.SRGBColorSpace,
      }}
    >
      <Suspense fallback={<Loader />}>
        <Model
          url={dtshirt}
          scale={[4.2, 4, 4.2]}
          position={[-8, -5, -2.9]}
          rotation={[0, 0, 0]}
        />

        <ambientLight intensity={0.5} />
        <directionalLight position={[5, 10, 5]} intensity={1} />

        <Environment preset="city" />
      </Suspense>

      <OrbitControls
        enableRotate={false}
        enableZoom={false}
        enablePan={false}
      />
    </Canvas>
  );
}